import { render } from "./03-AskForGeolocationPermissions.vue?vue&type=template&id=a9b42ed8"
import script from "./03-AskForGeolocationPermissions.vue?vue&type=script&lang=js"
export * from "./03-AskForGeolocationPermissions.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__